import { CompanyFilterContextProvider } from "../../superAdmin/components/context/CompanyFilterContext";
import CompanySales from '../../superAdmin/superdashboard/CompanySales'
import {CompanySalesContextProvider} from "../../superAdmin/superdashboard/context/CompanySalesContext";


const DASHBOARD_FILTER_CONFIG = {
    tiers: true,
    status: true,
    executive: true,
    companies: true,
    dateRange: true,
};

const SalesPage = () => {
    return (
        <CompanyFilterContextProvider filterConfig={DASHBOARD_FILTER_CONFIG}>
            <CompanySalesContextProvider>
                <CompanySales />
            </CompanySalesContextProvider>
        </CompanyFilterContextProvider>

    )

}

export default SalesPage;